var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"status-desc"},_vm._l((_vm.stateList),function(stateItem){return _c('div',{class:{'on':stateItem.field===_vm.currentSelState},on:{"click":function($event){_vm.selectState(stateItem.field)}}},[_c('span',[_vm._v(_vm._s(stateItem.name))]),_vm._v(" "),_c('span',[_vm._v("("+_vm._s(_vm.count[stateItem.field])+")")])])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f7912350","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/service/stateBall.vue
// module id = null
// module chunks = 